var cloneDeep = require('lodash.clonedeep');
import Vue from 'vue'

// DATA FOR LAYOUTS
export default {

    state: () => ({
      controls: [],
      boardName: "",
      boardCreator: "",
      layoutCollection: [],
      currentLayout: -1,
      tempLock : false,
      filterOpen: false,
      locked: true
    }),

    mutations: {
      setCurrentLayout: (state, data) => state.currentLayout = data,
      setControl: (state, { id, data }) => {
        var index = state.controls.findIndex(x => x.id == id)
        state.controls[index] = data
      },
      addControl: (state, data) => state.controls.push(cloneDeep(data)),
      removeControl: (state, index) => state.controls.splice(index, 1),
      setControls: (state, data) => Vue.set(state, "controls", data),
      setBoardName: (state, data) => state.boardName = data,
      setBoardCreator: (state, data) => state.boardCreator = data,
      setLayoutCollection: (state, data) => state.layoutCollection = data,
      setTempLock: (state, data) => state.tempLock = data,
      setFilterOpen: (state,data) => state.filterOpen = data,
      setLockedState: (state, data) => state.locked = data,
      setControlPosition: (state, {id, x, y}) => {
        var index = state.controls.findIndex(x=>x.id == id);
        if(index != -1){
          Vue.set(state.controls[index], "x", x)
          Vue.set(state.controls[index], "y", y)
        }
      }
    },
    
    getters: {
      boardName: (state) => state.boardName,
      boardCreator: (state) => state.boardCreator,
      controls: (state) => state.controls,
      layoutCollection: (state) => state.layoutCollection,
      currentLayout: (state) => state.currentLayout,
      tempLock: (state) => state.tempLock,
      filterOpen: (state) => state.filterOpen,
      locked: (state) => state.locked
    }
  }